import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import Cookies from 'universal-cookie';
import { Home } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  },
  backButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    fontSize: '16px',
    fontWeight: 'bold'
  }
}));

var cookies = new Cookies();

const NotFound = () => {
  const classes = useStyles();

  const handleBackToHome = () => {
    // Clear SiteUrl from cookies
    cookies.remove('SiteUrl');
    // Navigate to home
    window.location.href = '/';
  };

  return (
    <div className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid
          item
          lg={6}
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <div className={classes.content}>
            <Typography variant="h5">
              Trang không tồn tại. Vui lòng quay lại.
            </Typography>
            <img
              alt=""
              className={classes.image}
              src={
                process.env.REACT_APP_STATIC_URL +
                'images/undraw_page_not_found_su7k.svg'
              }
            />
          </div>
          <Button
            variant="primary"
            className={classes.backButton}
            style={{
              margin: 'auto',
              borderRadius: 50,
              display: 'flex',
              alignItems: 'center',
              gap: 10
            }}
            onClick={handleBackToHome}>
            <Home />
            Về trang chủ
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
